
const EditorialHeroSection = () => {
  return (
    <section
      className="relative w-full flex items-center justify-center overflow-hidden"
      style={{
        height: 'calc(100vh - 68px)', // Full viewport height minus header height
        backgroundColor: '#000000',
        backgroundImage: `url("/Editorial/Hero/hero.png")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Light overlay to ensure text readability */}
      <div
        className="absolute inset-0"
        style={{
          background: `linear-gradient(135deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.5) 100%)`
        }}
      ></div>
      
      {/* Hero Content */}
      <div className="relative z-10 text-center px-6 max-w-6xl mx-auto">
        <h1
          style={{
            fontFamily: 'Cardo, serif',
            fontSize: '80px',
            color: '#FFFFFF',
            fontWeight: '400',
            lineHeight: '1.1',
            textAlign: 'center',
            letterSpacing: '0.02em'
          }}
        >
          EDITORIAL
        </h1>
      </div>
    </section>
  )
}

export default EditorialHeroSection